import { PureComponent } from "react";
import Button from "segments/desktop/core-components/button/button";
import Title from "segments/desktop/core-components/title/title";
import { componentStyles } from "./timer-verticals-tabs-mobile-component.scss";
import VerticalTimerTabMobileComponent from "./vertical-timer-tab-mobile/vertical-timer-tab-mobile-component";

export default class TimerVerticalTabsMobileComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 0
    };
  }

  setSelectedTab = (newSelectedTab) => {
    const { timerEnabled } = this.props;

    this.setState((prevState) => ({
      selectedTab: !timerEnabled && prevState.selectedTab === newSelectedTab ? null : newSelectedTab
    }));
  };

  renderTabs = () => {
    const { selectedTab } = this.state;
    const {
      tabs,
      tabContentRenderer,
      assetQuality,
      title,
      showArrow,
      progressbarColor,
      rightSideRenderer,
      alwaysShowProgressbar,
      arrowSize,
      backgroundColor,
      tabTitleRenderer,
      getTabIdentifier
    } = this.props;
    const { fontSize, selectedFontSize, fontColor, selectedFontColor, fontWeight } = title || {};

    return tabs.map((tab, index) => {
      return (
        <VerticalTimerTabMobileComponent
          key={index}
          index={index}
          {...tab}
          getTabIdentifier={getTabIdentifier}
          isSelected={index === selectedTab}
          setSelectedTab={this.setSelectedTab}
          assetQuality={assetQuality}
          rightSideRenderer={rightSideRenderer}
          showArrow={showArrow}
          tabContentRenderer={tabContentRenderer}
          fontSize={fontSize}
          tabTitleRenderer={tabTitleRenderer}
          selectedFontSize={selectedFontSize}
          fontColor={fontColor}
          selectedFontColor={selectedFontColor}
          titleFontWeight={fontWeight}
          progressbarColor={progressbarColor}
          alwaysShowProgressbar={alwaysShowProgressbar}
          arrowSize={arrowSize}
          backgroundColor={backgroundColor}
        />
      );
    });
  };

  render() {
    const { showButton, buttonConfig, tabsTitle } = this.props;
    return (
      <div className="mobile-timer-tabs-component">
        {tabsTitle && (
          <div className="mobile-tabs-title-wrapper">
            <Title {...tabsTitle} />
          </div>
        )}
        {this.renderTabs()}
        {showButton && (
          <div className="mobile-button-link">
            <Button {...buttonConfig} />
          </div>
        )}
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
